import { render, staticRenderFns } from "./SubtransactionHistory.vue?vue&type=template&id=2c9a2d56&"
import script from "./SubtransactionHistory.vue?vue&type=script&lang=ts&"
export * from "./SubtransactionHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports